module.exports = __webpack_public_path__ + "static/media/Contrans.bbaa1961.png";